import FallingQuotesIndex from 'views/FallingQuotes/FallingQuotesIndex';
import FranchisesIndex from 'views/Franchises/FranchisesIndex';
import HotelsIndex from 'views/Hotels/HotelsIndex';
import OperatorsIndex from 'views/Operators/OperatorsIndex';
import ProfileForm from 'views/Profile/ProfileForm';
import ReasonsIndex from 'views/Reasons/ReasonsIndex';
import ReportHotelsIndex from 'views/ReportHotels/ReportIndex';
import ReportOperatorsIndex from 'views/ReportOperators/ReportIndex';
import ReportSalesIndex from 'views/ReportSales/ReportSalesIndex';
import StatusSalesIndex from 'views/StatusSales/StatusSalesIndex';
import UsersIndex from 'views/Users/UsersIndex';
import FallingQuotesForm from '../views/FallingQuotes/FallingQuotesForm';
import FranchiseReportsIndex from '../views/FranchiseReports/FranchiseReportsIndex';
import FranchisesForm from '../views/Franchises/FranchisesForm';
import HotelsForm from '../views/Hotels/HotelsForm';
import OperatorsForm from '../views/Operators/OperatorsForm';
import ReasonsForm from '../views/Reasons/ReasonsForm';
import UsersForm from '../views/Users/UsersForm';
import basicRoutes from './basicRoutes';
import FranchiseSummaryIndex from '../views/FranchiseSummary/FranchiseSummaryIndex';
import ReportClients from '../views/ReportClients/ReportIndex';

var dashboardRoutes = [
  ...basicRoutes,

  {
    collapse: true,
    path: '/config',
    name: 'Configuracion',
    state: 'Configuracion',
    icon: 'pe-7s-box2',
    views: [
      {
        path: '/admin/config/hotels/:id',
        name: 'Hoteles',
        component: HotelsForm,
        invisible: true
      },
      {
        path: '/admin/config/hotels',
        name: 'Hoteles',
        icon: 'pe-7s-map-marker',
        component: HotelsIndex
      },
      {
        path: '/admin/config/operators/:id',
        name: 'Operadores',
        component: OperatorsForm,
        invisible: true
      },
      {
        path: '/admin/config/operators',
        name: 'Operadores',
        icon: 'pe-7s-map-marker',
        component: OperatorsIndex
      },
      {
        path: '/admin/config/franchises/:id',
        name: 'Franquicias',
        component: FranchisesForm,
        invisible: true
      },
      {
        path: '/admin/config/franchises',
        name: 'Franquicias',
        icon: 'pe-7s-map-marker',
        component: FranchisesIndex
      },
      {
        path: '/admin/config/reasons/:id',
        name: 'Causas de caídas',
        component: ReasonsForm,
        invisible: true
      },
      {
        path: '/admin/config/reasons',
        name: 'Causas de caídas',
        icon: 'pe-7s-map-marker',
        component: ReasonsIndex
      },

      {
        path: '/admin/config/status-sales',
        name: 'Estatus de Ventas',
        icon: 'pe-7s-map-marker',
        component: StatusSalesIndex
      },
      {
        path: '/admin/users/:id',
        name: 'Usuarios',
        component: UsersForm,
        invisible: true
      },
      {
        path: '/admin/users',
        name: 'Usuarios',
        icon: 'pe-7s-users',
        component: UsersIndex
      },
      {
        path: '/admin/profile',
        name: 'Perfil',
        icon: 'pe-7s-user',
        component: ProfileForm,
        invisible: false
      }
    ]
  },
  {
    collapse: true,
    path: '/reports',
    name: 'Informes',
    state: 'Informes',
    icon: 'pe-7s-box2',
    views: [
      {
        path: '/admin/reports/falling-quotes/:id',
        name: 'Cotizaciones caídas',
        component: FallingQuotesForm,
        invisible: true
      },
      {
        path: '/admin/reports/falling-quotes',
        name: 'Cotizaciones caídas',
        icon: 'pe-7s-attention',
        component: FallingQuotesIndex
      },
      {
        path: '/admin/reports/sales',
        name: 'Reportes Ventas',
        icon: 'pe-7s-attention',
        component: ReportSalesIndex
      },
      {
        path: '/admin/reports/hotels',
        name: 'Reportes Hoteles',
        icon: 'pe-7s-attention',
        component: ReportHotelsIndex
      },
      {
        path: '/admin/reports/operators',
        name: 'Reportes Operadores',
        icon: 'pe-7s-attention',
        component: ReportOperatorsIndex
      },

      {
        path: '/admin/reports/franchise-reports',
        name: 'Reportes Franquicias',
        icon: 'pe-7s-attention',
        component: FranchiseReportsIndex
      },
      {
        path: '/admin/reports/franchise-summary',
        name: 'Concentrado de Franquicias',
        icon: 'pe-7s-attention',
        component: FranchiseSummaryIndex
      },
      {
        path: '/admin/reports/clients',
        name: 'Reporte de Clientes',
        icon: 'pe-7s-attention',
        component: ReportClients,
      },
    ]
  },

  { redirect: true, path: '/', pathTo: '/iniciar-sesion', name: 'Dashboard' }
];
export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboardSupport.jsx